import { WrenchTheme } from '@wds/styles';
import { merge } from 'lodash';

const changes = {
	palette: {
		name: 'Default',
		primary: {
			main: '#007500',
			contrast: '#FFFFFF',
			hover: '#00AD65',
			pressed: '#007500',
		},
		success: {
			main: '#00BF6F',
			contrast: '#FFFFFF',
			hover: '#009E5C',
			pressed: '#009E5C',
		},
	},
};

export const DefaultTheme = merge({}, WrenchTheme, changes);
